import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule)
      },
      {
        path: 'info',
        loadChildren: () => import ('./business-info/business-info.module').then(mod => mod.BusinessInfoModule)
      },
      {
        path: 'loyalty',
        loadChildren: () => import ('./loyalty/loyalty.module').then(mod => mod.LoyaltyModule)
      },
      {
        path: 'glns',
        loadChildren: () => import ('./business-codes/business-codes.module').then(mod => mod.BusinessCodesModule)
      },
      {
        path: 'account',
        loadChildren: () => import ('./account-info/account-info.module').then(mod => mod.AccountInfoModule)
      },
      {
        path: 'chat',
        loadChildren: () => import ('./chat/chat.module').then(mod => mod.ChatModule)
      },
      {
        path: 'customers',
        loadChildren: () => import ('./customers/customers.module').then(mod => mod.CustomersModule)
      },
      {
        path: 'distributors',
        loadChildren: () => import('./distributors/distributors.module').then(mod => mod.DistributorsModule)
      },
      {
        path: 'interactions',
        loadChildren: () => import ('./interactions/interactions.module').then(mod => mod.InteractionsModule)
      },
      {
        path: 'products',
        loadChildren: () => import('./products/products.module').then(mod => mod.ProductsModule),
      },
      {
        path: 'shops',
        loadChildren: () => import ('./shops/shops.module').then(mod => mod.ShopsModule)
      },
      {
        path: 'media',
        loadChildren: () => import ('./media/media.module').then(mod => mod.MediaModule)
      },
      {
        path: 'settings',
        loadChildren: () => import ('./settings/settings.module').then(mod => mod.SettingsModule)
      },
      {
        path: 'log-call',
        loadChildren: () => import ('./log-call/log-call.module').then(mod => mod.LogCallModule)
      },
      {
        path: 'guide',
        loadChildren: () => import ('./guide/guide.module').then(mod => mod.GuideModule)
      },
      {
        path: 'agent-ctv',
        loadChildren: () => import ('./agent-ctv/agent-ctv.module').then(mod => mod.AgentCtvModule)
      }
    ])
  ],
  exports: [RouterModule]
})

export class BusinessRoutingModule {
}
